import type { FormDialogModel } from './hooks/useFormDialog';
import type { TabItem } from '@/components/custom/erp';
import { PaymentInfoTab } from './PaymentInfoTab';
import { DetailTab } from './DetailTab';
import { OtherTab } from './OtherTab';
import { RateTab } from './RateTab';
import { TaxTab } from './TaxTab';

export const FormTabs = (dialog: FormDialogModel): TabItem[] => {
  if (dialog.activeTab !== 'info') return [];

  const tabs: TabItem[] = [
    {
      id: 'details',
      label: 'Chi tiết',
      component: (
        <DetailTab
          formMode={dialog.formMode}
          rows={dialog.detail.rows}
          selectedRowUuid={dialog.detail.selectedRowUuid}
          selectedCell={dialog.detail.selectedCell}
          onRowClick={dialog.detail.handleRowClick}
          onCellClick={dialog.detail.handleCellClick}
          onAddRow={dialog.detail.handleAddRow}
          onDeleteRow={dialog.detail.handleDeleteRow}
          onCopyRow={dialog.detail.handleCopyRow}
          onPasteRow={dialog.detail.handlePasteRow}
          onMoveRow={dialog.detail.handleMoveRow}
          onCellValueChange={dialog.detail.handleCellValueChange}
          onRepeatForRows={dialog.detail.repeatRows}
          handleUpdateNonWritableFields={dialog.detail.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.detail.setPasteConfigs}
        />
      )
    }
  ];

  if (dialog.formState.state.loaiPhieuChi !== '4') {
    tabs.push(
      {
        id: 'tax',
        label: 'Thuế',
        component: (
          <TaxTab
            formMode={dialog.formMode}
            rows={dialog.tax.rows}
            selectedRowUuid={dialog.tax.selectedRowUuid}
            selectedCell={dialog.tax.selectedCell}
            onRowClick={dialog.tax.handleRowClick}
            onCellClick={dialog.tax.handleCellClick}
            onAddRow={dialog.tax.handleAddRow}
            onDeleteRow={dialog.tax.handleDeleteRow}
            onCopyRow={dialog.tax.handleCopyRow}
            onPasteRow={dialog.tax.handlePasteRow}
            onMoveRow={dialog.tax.handleMoveRow}
            onCellValueChange={dialog.tax.handleCellValueChange}
            onRepeatForRows={dialog.tax.repeatRows}
            handleUpdateNonWritableFields={dialog.tax.setNonWritableFields}
            handleUpdatePasteConfigs={dialog.tax.setPasteConfigs}
          />
        )
      },
      {
        id: 'payment',
        label: 'Thanh toán',
        component: <PaymentInfoTab formMode={dialog.formMode} formState={dialog.formState} />
      }
    );
  }

  tabs.push(
    {
      id: 'rate',
      label: 'Tỷ giá',
      component: <RateTab formMode={dialog.formMode} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab formMode={dialog.formMode} rows={dialog.detail.rows} />
    }
  );

  return tabs;
};
